export interface TeamMember {
  name: string;
  role: string;
  image: string;
  description: string;
}

export const teamMembers: TeamMember[] = [
  {
    name: "Dr Fatima Kurnaz DDS (MELB)",
    role: "Principal Dentist & Founder",
    image: "/DR%20Fatima%20Headshot%20New.png?v=20260421",
    description: "Dr Fatima provides modern, gentle and ethical dentistry with a strong focus on patient comfort and long-term oral health."
  },
  {
    name: "Dr Pinar Geyik BDS",
    role: "Associate Dentist",
    image: "/Dr%20Pinar.svg",
    description: "Dr Pinar offers calm, patient-centred care with interests in cosmetic dentistry, prevention, and minor oral surgery."
  },
  {
    name: "Dr Javed Mahmud (AKA Dr Pavel)",
    role: "Senior Dentist",
    image: "/Dr%20Pavel.svg",
    description: "Dr Pavel focuses on implant consultations, oral surgery, and restorative care with a gentle, detail-oriented approach."
  }
];
